import { AuthPort } from '../ports/AuthPort';
import { IdentityRepository } from '../ports/IdentityRepository';

export class InviteStaffUseCase {
  constructor(
    private authPort: AuthPort,
    private identityRepo: IdentityRepository
  ) {}

  async execute(email: string, role: string, storeId: string): Promise<void> {
    const authRes = await this.authPort.inviteUser(email, role, { storeId });
    // Note: Profile creation is usually handled by a database trigger in Supabase on auth.users insert.
    // However, if we need to manually assign, we'd wait for user to exist.
    // For now, we assume the invitation is sent and the user will be assigned on first login or via trigger.
  }
}
